export const createSearchForm = (imgPath: string) => {
  const formElement = document.createElement('form');
  formElement.setAttribute('style', 'display:none');
  document.body.appendChild(formElement);
  formElement.setAttribute('action', '/search-photo/gallery');
  formElement.setAttribute('method', 'post');

  const input = document.createElement('input');
  formElement.appendChild(input);
  input.setAttribute('name', 'file');
  input.value = imgPath;

  formElement.submit();
};
